<template>
	<v-card height="500">
		<v-toolbar flat class="slimtoolbar">
			<v-toolbar-title >FLOORS</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items v-if="isSuperUser" style="position: relative; top: -5px; right: -20px;"  >
				<v-tooltip top >
					<DeleteFloorDialog slot="activator" :icon="'delete'" />
					<span>Delete Floor</span>
				</v-tooltip>

 				<v-tooltip top >
					<EditFloorDialog slot="activator" :icon="'add_circle_outline'" :newFlr="true"/>						
					<span>Add Floor</span>
				</v-tooltip> 
				
				<v-tooltip top >
					<EditFloorDialog slot="activator" :icon="'edit'" />
					<span>Edit Floor</span>
				</v-tooltip>
			</v-toolbar-items>

		</v-toolbar>
		<v-layout row>
			<v-flex xs2 class="">
				<v-list dense style="overflow-y: auto; height: 190px;"
					 class="pt-0">
					<v-list-tile
						v-for="(item, index) in building.floors"
						:key="item"
						avatar
						@click="getFloor(item)"
						class="elevatorlist "
						:class="{
							selected:
								selected == item || (!selected && index == 0)
						}"
					>
						<v-list-tile-content>
							<v-list-tile-title
								
								v-text="item"
							></v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
				</v-flex>


			<v-flex class="ml-4">
				<v-data-table
					v-if="floor"
					:items="items"
					hide-actions
					hide-headers
					class="mt-3 floorTable"
				>
					<template slot="items" slot-scope="props">
						<tr
							v-for="(key, index) in Object.keys(props.item)" v-bind:key="index"
							:index="index"
						>
							<td>{{ key }}</td>
							<td>{{ props.item[key] }}</td>
						</tr>
					</template>
				</v-data-table>
			
				<br/>
			
				<div>
					<span class="body-2">{{ this.floor.drawings.length > 1 ?  'Drawings' : 'Drawing' }}</span> 
					<v-list-tile v-for="(item, index) in floor.drawings" :key="index" style="height:30px;">
						<v-list-tile-content> 
							<v-list-tile-title v-text="item.drawing" class="body-1"></v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</div>
			</v-flex>
		</v-layout>


		

	</v-card>
</template>

<script>
import Vuex from "vuex";
import { mapState, mapMutations, mapActions } from "vuex";
import EditFloorDialog from './EditFloorDialog'
import DeleteFloorDialog from './DeleteFloorDialog'

export default {
	name: "FloorDetail",
	components : { EditFloorDialog, DeleteFloorDialog  },
	data() {
		return {
			fieldsToShow: 	[ 'grossArea', 'useableArea', 'assignableArea', 'nonAssignableArea', 'areaType' ]
		};
	},

	computed: {
		...mapState({
			floor: state => state.dv.floor,
			building: state => state.dv.building,
			isSuperUser: state => state.user.isSuperUser,
		}),

		selected: {
			    get () {
                  return this.floor && this.floor.floorNumber
                },

                set () {
                   // Do Nothing
                }
			
		}, 

		items: function () {		
			const filtered = Object.keys(this.floor)
				  .filter(key => this.fieldsToShow.includes(key))
				  .reduce((obj, key) => {
				    obj[key] = this.floor[key];
				    return obj;
				  }, {});
			let fa = []
			fa.push( filtered )
			return fa
		}

	},

	methods: {
		...mapActions(["fetchFloor"]),

		...mapMutations(["setdvFloor", 'setdvFloor']),

		

		getFloor: function(flooritem) {
			this.fetchFloor({
				bldgAlpha: this.building.bldgAlpha,
				floor: flooritem
			}).then(data => {
				this.setdvFloor(data);
				this.selected = flooritem;
			});
		},
	},
};
</script>

<style>
.elevatorlist > .v-list__tile {
	height: 25px !important;
}

.floorTable {
	/*height: calc(45vh - 277px) !important; */
	overflow-y: auto !important;
}

/* this technique gets deeply nested th td selectors */
.floorTable th {
	padding-left: 0px !important;
}
.floorTable td {
	padding-left: 0px !important;
	padding-right: 0px;
	height: 10px !important;
}
.floorTable .v-table__overflow {
	overflow-x: unset !important;
	overflow-y: unset !important;
}

.floorTable .table {
	padding-left: 0px;
	border-radius: 0px;
}

.selected {
	background-color: #a2a2a2;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/FloorDetail.vue